import React from 'react';
import PropTypes from 'prop-types';
import { Row as TableRow, Cell, StickyTable } from 'react-sticky-table';
import EditableToggleCell from '../../consultantHealthInsurer/EditableToggleCell';
import EditableProviderNumberCell from '../../consultantHealthInsurer/EditableProviderNumberCell';
import StickyCcsdCodeCostRow from '../../ccsdCodeCost/StickyCcsdCodeCostRow';
import EditableConsultantHealthInsurerLabelCell from '../../consultantHealthInsurer/EditableConsultantHealthInsurerLabelCell';
import MASpinner from '../../common/MASpinner';
import { sortHealthInsurersByName } from '../../../lib/helper/general';

class ConsultantCcsdCodeCostTable extends React.Component {
  render() {
    const { consultant, consultantType, ccsdCodes, ccsdCodeCosts, reloadCodes, isFetchingCcsdCodeCosts = false, onFeeAssuredUpdate } = this.props;
    if (!consultant.consultantHealthInsurers) {
      return null;
    }
    return (
      <>
        <div className="crud__section mb-3">
          <div className="crud__section-icon">{isFetchingCcsdCodeCosts ? <MASpinner wrapperClasses={''} /> : <i className="fas fa-coins" />}</div>
          <h2 className="crud__section-header">CCSD code costs ({consultantType.displayName})</h2>
          <div style={{ width: '100%', height: '500px' }}>
            <StickyTable stickyHeaderCount={2} leftStickyColumnCount={1}>
              <TableRow>
                <Cell className="sticky-table-cell batch-invoice-ccsd-code-title-column">Code</Cell>
                {consultant.consultantHealthInsurers.sort(sortHealthInsurersByName).map((consultantHealthInsurer) => (
                  <EditableConsultantHealthInsurerLabelCell key={consultantHealthInsurer.healthInsurer.id} consultantHealthInsurer={consultantHealthInsurer} />
                ))}
              </TableRow>
              <TableRow>
                <Cell>Fee Assured</Cell>
                {consultant.consultantHealthInsurers.sort(sortHealthInsurersByName).map((consultantHealthInsurer) => {
                  return consultantHealthInsurer.healthInsurer.isAnalogue ? (
                    <Cell key={consultantHealthInsurer.healthInsurer.id} className="border-right" />
                  ) : (
                    <EditableToggleCell
                      key={consultantHealthInsurer.healthInsurer.id}
                      consultantHealthInsurer={consultantHealthInsurer}
                      consultantCreatedDate={consultant.createdAt}
                      consultant={consultant}
                      reloadCodes={reloadCodes}
                      fieldName="feeAssured"
                      label="Fee Assured"
                      idPrefix="default-feeAssured"
                      dateFieldName="feeAssuredLastChangeDate"
                      onAfterUpdate={onFeeAssuredUpdate}
                    />
                  );
                })}
              </TableRow>
              <TableRow>
                <Cell>Remittance in</Cell>
                {consultant.consultantHealthInsurers.sort(sortHealthInsurersByName).map((consultantHealthInsurer) => {
                  return consultantHealthInsurer.healthInsurer.isAnalogue ? (
                    <Cell key={consultantHealthInsurer.healthInsurer.id} className="border-right" />
                  ) : (
                    <EditableToggleCell
                      key={consultantHealthInsurer.healthInsurer.id}
                      consultantHealthInsurer={consultantHealthInsurer}
                      consultantCreatedDate={consultant.createdAt}
                      reloadCodes={reloadCodes}
                      fieldName="remittanceInChangeDate"
                      label="Remittance In"
                      idPrefix="default-remittance-in"
                      useDateValue
                      disabledWhenChecked
                      recordedByFieldName="remitanceInDateRecordedBy"
                    />
                  );
                })}
              </TableRow>
              <TableRow>
                <Cell>Payment in</Cell>
                {consultant.consultantHealthInsurers.sort(sortHealthInsurersByName).map((consultantHealthInsurer) => {
                  return consultantHealthInsurer.healthInsurer.isAnalogue ? (
                    <Cell key={consultantHealthInsurer.healthInsurer.id} className="border-right" />
                  ) : (
                    <EditableToggleCell
                      key={consultantHealthInsurer.healthInsurer.id}
                      consultantHealthInsurer={consultantHealthInsurer}
                      consultantCreatedDate={consultant.createdAt}
                      reloadCodes={reloadCodes}
                      fieldName="paymentInChangeDate"
                      label="Payment In"
                      idPrefix="default-payment-in"
                      useDateValue
                      disabledWhenChecked
                      recordedByFieldName="paymentInDateRecordedBy"
                    />
                  );
                })}
              </TableRow>
              <TableRow>
                <Cell>Providers No</Cell>
                {consultant.consultantHealthInsurers.sort(sortHealthInsurersByName).map((consultantHealthInsurer) => {
                  return consultantHealthInsurer.healthInsurer.isAnalogue ? (
                    <Cell key={consultantHealthInsurer.healthInsurer.id} className="border-right" />
                  ) : (
                    <EditableProviderNumberCell key={consultantHealthInsurer.healthInsurer.id} consultantHealthInsurer={consultantHealthInsurer} />
                  );
                })}
              </TableRow>
              {ccsdCodes.map((ccsdCode) => (
                <StickyCcsdCodeCostRow
                  key={ccsdCode.id}
                  ccsdCode={ccsdCode}
                  ccsdCodeCosts={ccsdCodeCosts}
                  consultantHealthInsurers={consultant.consultantHealthInsurers}
                  consultantType={consultantType}
                />
              ))}
            </StickyTable>
          </div>
        </div>
      </>
    );
  }
}

export default ConsultantCcsdCodeCostTable;

ConsultantCcsdCodeCostTable.propTypes = {
  consultant: PropTypes.object.isRequired,
  ccsdCodes: PropTypes.array.isRequired,
};
